import myAPI from './resources'
import config from '../config'

export default {

  getApprovedZipCodes: async function (zipCode) {
    return await myAPI.get(config.carbuyservice + '/approvedzipCode/' + zipCode);
  },
  getStateFromZipCode: async function (zipCode) {
    return await myAPI.get(config.enterpriseservice + '/zipCode/' + zipCode);
  },
  getMarketFromLocID: async function (locationID) {
    // await myAPI.get(config.enterpriseservice + '/location/' + locationID + '/market').then((response) => {
    //   console.log("LOCID: ", response)
    // })
    return await myAPI.get(config.enterpriseservice + '/location/' + locationID + '/market');
  },
  getAllMarkets: async function () {
    return await myAPI.get(config.enterpriseservice + '/market');
  }
}


// WEBPACK FOOTER //
// ./src/api/zipcode.js